import React from 'react';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-cookr">
      <div className="container">
        <h2 className="section-title-cookr">
          Why Choose Us?
        </h2>
        
        <div className="features-layout-cookr">
          <div className="background-image">
            <img src="/assets/images/homepage-one/why-choose-bg.jpg" alt="Healthy Food" />
          </div>
          
          <div className="features-container">
            <div className="feature-card-cookr" id="feature-1">
              <div className="feature-content">
                <h3 className="feature-title">Homemade Quality</h3>
                <p className="feature-description">Every meal is crafted with love, just like home.</p>
              </div>
            </div>
            
            <div className="feature-card-cookr" id="feature-2">
              <div className="feature-content">
                <h3 className="feature-title">On-Time Delivery</h3>
                <p className="feature-description">Enjoy fresh, delicious subscription meals delivered right to your door.</p>
              </div>
            </div>
            
            <div className="feature-card-cookr" id="feature-3">
              <div className="feature-content">
                <h3 className="feature-title">Customizable Plans</h3>
                <p className="feature-description">Tailor your subscription to fit your lifestyle and preferences.</p>
              </div>
            </div>
            
            <div className="feature-card-cookr" id="feature-4">
              <div className="feature-content">
                <h3 className="feature-title">Flexible Scheduling</h3>
                <p className="feature-description">Adjust your delivery days anytime.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;